<mat-form-field appearance="outline" class="max-width no-hint">
  <mat-label>{{ 'general.api_cart_code_gift' | translate }}</mat-label>
  <input matInput type="text" name="giftCode" [(ngModel)]="giftCode" [disabled]="disabled"
         (keyup)="utilService.isEnterKey($event) ? addGiftCode() : null" autocomplete="off">
  <a matSuffix class="link" (click)="$event.stopPropagation(); !disabled && addGiftCode()" [attr.aria-disabled]="disabled">
    <span>{{ 'general.api_cart_code_gift_add' | translate }}</span>
  </a>
</mat-form-field>
<mat-chip-listbox *ngIf="service.cart?.giftCards?.length">
  <ng-container *ngFor="let giftCard of service.cart.giftCards">
    <mat-chip-option *ngFor="let giftCode of giftCard.codes" [selectable]="false">
      {{giftCode.code}} ({{giftCode.credit | price}})
      <button matChipRemove (click)="removeGiftCode(giftCode)" [disabled]="disabled">
        <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
      </button>
    </mat-chip-option>
  </ng-container>
</mat-chip-listbox>
